module.exports = __webpack_public_path__ + "static/img/h3-5.69e5262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h3-5.png
// module id = q9dt
// module chunks = 1